
// src/web/components/draft-selection-dialog.jsx

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import connect from '../../connects/draft-selection-dialog'
import classnames from 'classnames'
import _ from 'lodash'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  List,
  ListItem,
  ListDivider
} from 'react-toolbox/lib/list'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import ScrollableDialogPanel from './scrollable-dialog-panel.jsx'
import theme from './themes/action-dialog.css'
import ConfirmDialog from './confirm-dialog.jsx'
import DiaryTimestamp from './diary-timestamp.jsx'

class DraftSelectionDialog extends PureComponent {
  state = { confirmId: undefined, isOpen: false }
  cancelDeleteMessage = ()=> this.setState({ confirmId: undefined, isOpen: false })

  onDeletePress = (diary_id) => {
    this.props.deleteSavedDiary(diary_id)
    this.setState({ confirmId: undefined })
  }

  onEditPress = (diary_id) => {
    this.props.editSavedDiary(diary_id)
    this.props.onClose()
  }

  onRightClick = (diary_id) => this.setState({ confirmId: diary_id })

  onOpen = () => this.setState({ isOpen: true })
  onDeleteAllPress = (group_id) => {
    this.props.deleteAllSavedDiary(group_id)
    this.setState({ isOpen: false })
  }

  getRowText = (html) => {
    if (!html || html.length == 0)
        return null
      const rowText = html.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
            .replace(/ ?:emoji-([-0-9a-f]+): ?/ig, '')
            .replace(/^[ \t\n\r\f]+|\s+$/g, '')
    return rowText.slice(0, 50)
  }
  render() {
    const {
      t,
      active,
      diaries,
      onClose,
      isEdit,
      isFetching,
      updateUI,
      group
    } = this.props
    
    if(!diaries){
      return null
    }

    return (
      <Dialog active={active} theme={theme}
        title={t('label:下書きを選択')}
        actions={[
          { raised: true, label: t('label:取り消し'), onClick: onClose },
        ]}
        onOverlayClick={onClose}
        onEscKeyDown={onClose} >
        <ScrollableDialogPanel>
          <Button icon='delete' label={t('label:全て削除')} raised style={{ marginLeft: 4, marginTop: 4 }} onClick={() => this.onOpen()}/>
          <List>
            {diaries && _.map(diaries, (diary, i)=> 
              <div key={i}>
              <ListItem  selectable  theme={theme} className={'text_hidden'}
                onClick={() => this.onEditPress(diary.diary_id)}
                caption={this.getRowText(diary.subject) || t('format:diary_subject', { reported_at: diary.reported_at, category: t('diary:' + diary.category) })}
                legend={<div><div style={{ marginLeft: 3 }}>{this.getRowText(diary.content)}</div><DiaryTimestamp timestamp={diary.updated_at}/></div>}
                rightActions={[<IconButton icon='close' key='icon'
                onClick={() => this.onRightClick(diary.diary_id)} />]} />
              <ListDivider />
              <ConfirmDialog title={t('label:保存された投稿を削除してもいいですか')}
                  description={t('label:この操作は取り消せません')}
                  open={this.state.confirmId == diary.diary_id}
                  onYes={() => this.onDeletePress(diary.diary_id)}
                  onNo={this.cancelDeleteMessage}
                  yesLabel={t('label:削除')}
                  noLabel={t('label:取り消し')} />
               </div>
            )}
            </List>
            <ConfirmDialog title={t('label:保存された全ての投稿を削除してもいいですか')}
                  description={t('label:この操作は取り消せません')}
                  open={this.state.isOpen}
                  onYes={() => this.onDeleteAllPress(group.group_id)}
                  onNo={this.cancelDeleteMessage}
                  yesLabel={t('label:削除')}
                  noLabel={t('label:取り消し')} />
        </ScrollableDialogPanel>
      </Dialog>
    )
  }
}

export const RawDraftSelectionDialog = DraftSelectionDialog
export default connect(DraftSelectionDialog)



// WEBPACK FOOTER //
// ./src/web/components/draft-selection-dialog.jsx